import { FormCard, FormItem, FormRadioGroup } from '@lmc/ui-kit'
import { Heading } from '@lmc/ui-kit/src/general'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { VISIT } from '../constants'
import Asterix from '../RotaPattern/components/Asterix'
import type { RotaPatternModalType } from '../RotaPattern/utils'
import { getRequiredRule } from '../utils'

type ReoccurenceToogleProps = { type?: RotaPatternModalType }

const ReoccurenceToogle: FC<ReoccurenceToogleProps> = ({ type = VISIT }) => {
  const { t } = useTranslation()

  const options = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ]

  return (
    <FormCard
      level={2}
      title={
        <StyledHeading level={2}>
          <Asterix /> {t('IS_THIS_RECURRING', { variable: type })}
        </StyledHeading>
      }
      subtitle={t('CHOOSE_NO', { variable: type })}
    >
      <FormItem
        name="reoccurenceTooglePattern"
        rules={[getRequiredRule(t('CHOOSE_NO', { variable: type }))]}
      >
        <StyleRadioGroup
          options={options}
          style={{ display: 'flex', flexDirection: 'row' }}
        />
      </FormItem>
    </FormCard>
  )
}

const StyleRadioGroup = styled(FormRadioGroup)`
  .ant-radio-wrapper {
    width: unset;
    background-color: transparent !important;
  }
`

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
  font-size: 20px;
`

export default ReoccurenceToogle
